var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-rg-bottom-panel",style:({'margin-topd':(_vm.graphSetting.viewSize.height-_vm.height)+'px', height: _vm.height+'px', 'margin-top': -_vm.height+'px' })},[_vm._t("bottomPanel")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }